import { parseHtml } from '@healthhub/react-ui';

import type { DisabledIf, EnableWhen, TemplateFormItem, Validation } from '@shared/types/form.types';
import { Operators } from '@shared/types/form.types';

export const getEnableWhenValidation = ({
  enableWhen,
  questionValue,
}: {
  enableWhen?: EnableWhen | null;
  questionValue?: string | string[];
}) => {
  if (!enableWhen) return true;

  const { Answer, Operator } = enableWhen;

  switch (Operator) {
    case Operators.Contain:
      return Answer.some((value) => String(questionValue).includes(value.toString()));
    case Operators.Equal:
      return Answer.some((value) => value === questionValue);
    default:
      return true;
  }
};

export const getValidationMessage = ({ validations, value }: { validations?: Validation[]; value: boolean | string }) =>
  validations?.find((validation) => validation?.Conditions?.some((item) => item === value))?.Message;

export const getFormOptionsFormatter = (answerOptions: string[]) =>
  answerOptions?.map((option) => ({
    label: parseHtml(option),
    value: option,
  }));

export const getIsQuestionDisabled = (disabledIf: DisabledIf, questionValue: string) =>
  disabledIf.Operator === Operators.NotEqual && questionValue !== disabledIf.Value;

export const getValueByLinkId = (linkId: string, data?: TemplateFormItem[]) => {
  if (!data) return undefined;
  const item = data.find((item) => item.LinkId === linkId);
  return item ? item.Value : undefined;
};
